import * as types from '../../../lib/actionTypes.es6';

export const getOrganizationsRequest = function() {
  return { type: types.GET_ORGANIZATIONS_REQUEST };
};

export const getOrganizationsSuccess = function(payload) {
  return { type: types.GET_ORGANIZATIONS_SUCCESS, payload: payload };
};

export const getOrganizationsFailure = function(error) {
  return { type: types.GET_ORGANIZATIONS_FAILURE, payload: error };
};

export const getOrganizationRequest = function(guid) {
  return { type: types.GET_ORGANIZATION_REQUEST, payload: guid };
};

export const getOrganizationSuccess = function(payload) {
  return { type: types.GET_ORGANIZATION_SUCCESS, payload: payload };
};

export const getOrganizationFailure = function(error) {
  return { type: types.GET_ORGANIZATION_FAILURE, payload: error };
};

export const createOrganizationRequest = function(payload) {
  return { type: types.CREATE_ORGANIZATION_REQUEST, payload: payload };
};

export const createOrganizationSuccess = function(payload) {
  return { type: types.CREATE_ORGANIZATION_SUCCESS, payload: payload };
};

export const createOrganizationFailure = function(error) {
  return { type: types.CREATE_ORGANIZATION_FAILURE, payload: error };
};

export const resetCreateOrganizationSuccess = function() {
  return { type: types.RESET_CREATE_ORGANIZATION_SUCCESS };
};

export const resetCreateOrganizationError = function() {
  return { type: types.RESET_CREATE_ORGANIZATION_ERROR };
};

export const updateOrganizationRequest = function(payload) {
  return { type: types.UPDATE_ORGANIZATION_REQUEST, payload: payload };
};

export const updateOrganizationSuccess = function(payload) {
  return { type: types.UPDATE_ORGANIZATION_SUCCESS, payload: payload };
};

export const updateOrganizationFailure = function(error) {
  return { type: types.UPDATE_ORGANIZATION_FAILURE, payload: error };
};

export const resetUpdateOrganizationSuccess = function() {
  return { type: types.RESET_UPDATE_ORGANIZATION_SUCCESS };
};

export const resetUpdateOrganizationError = function() {
  return { type: types.RESET_UPDATE_ORGANIZATION_ERROR };
};

export const deleteOrganizationRequest = function(guid) {
  return { type: types.DELETE_ORGANIZATION_REQUEST, payload: guid };
};

export const deleteOrganizationSuccess = function(payload) {
  return { type: types.DELETE_ORGANIZATION_SUCCESS, payload: payload };
};

export const deleteOrganizationFailure = function(error) {
  return { type: types.DELETE_ORGANIZATION_FAILURE, payload: error };
};

export const resetDeleteOrganizationSuccess = function() {
  return { type: types.RESET_DELETE_ORGANIZATION_SUCCESS };
};

export const resetDeleteOrganizationError = function() {
  return { type: types.RESET_DELETE_ORGANIZATION_ERROR };
};
